import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import {
  ConsultationListItem,
  PatientState,
  SectionForm,
  SubSectionForm
} from './types'
// import { PatientMutations } from './mutations'

export const getters: GetterTree<PatientState, RootState> = {
  getMorbidityRegistrySection: state => (section: string) => {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.morbidityRegistry.filter(
        (event: SectionForm) => event.children == section //'Hoja de morbilidad obstétrica'
      )
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getResolutionEventDate: state => () => {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.morbidityRegistry
        .find(
          (event: SectionForm) => event.section == 'Morbilidad neonato' //'Hoja de morbilidad obstétrica'
        )
        ?.subSections.find(x => x.id == 370)?.userResponseValue[0]?.birthDate
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getClinicalHistorySection: state => (section: string) => {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.clinicalHistory.filter(
        (event: SectionForm) => event.children == section //'Hoja de morbilidad obstétrica'
      )
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getCurrentConditionSection: state => (section: string) => {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.currentCondition.filter(
        (event: SectionForm) => event.children == section //'Hoja de morbilidad obstétrica'
      )
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getScheduledConsultations(state) {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.patientConsultationsList.filter(
        (event: ConsultationListItem) => event.status == 81 //'Hoja de morbilidad obstétrica'
      )
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getConsultation: state => (consultationId: number) => {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.patientConsultationsList.find(
        (event: ConsultationListItem) => event.id == consultationId //'Hoja de morbilidad obstétrica'
      )
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getStartedConsultations(state) {
    try {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
      return state.patientConsultationsList.filter(
        (event: ConsultationListItem) => event.status != 81 //'Hoja de morbilidad obstétrica'
      )
    } finally {
      //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
    }
  },

  getItemClinicalHistory:
    state =>
    (
      children: string,
      section: string,
      dependsOn: string,
      dependsOnValue: string | null
    ) => {
      try {
        //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
        let resp = false
        if (dependsOn == null) return true
        let depends = dependsOn.split('|')
        depends.forEach((element: string) => {
          let item = state.clinicalHistory
            .find(
              (event: SectionForm) =>
                event.children == children && event.section == section //'Hoja de morbilidad obstétrica'
            )
            ?.subSections.find(
              (sub: SubSectionForm) => sub.id == Number(element)
            )
          if (
            item == undefined ||
            item.userResponseValue === 'Otro' ||
            item.userResponseValue === 'Otra' ||
            (dependsOnValue != null &&
              dependsOnValue
                .split('|')
                .find(x => x == item?.userResponseValue) != undefined) ||
            (dependsOnValue === null && item?.userResponseValue === true) ||
            (dependsOnValue === '>0' && item?.userResponseValue > 0) ||
            (dependsOnValue === '!=null' && item?.userResponseValue != null) //||
          ) {
            resp = true
          }
        })
        return resp
      } finally {
        //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
      }
    },

  getItemMorbidityRegistry:
    state =>
    (
      children: string,
      section: string,
      dependsOn: string,
      dependsOnValue: string | null
    ) => {
      try {
        //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
        let resp = false
        if (dependsOn == null) return true
        let depends = dependsOn.split('|')
        depends.forEach((element: string) => {
          let item = state.morbidityRegistry
            .find(
              (event: SectionForm) =>
                event.children == children && event.section == section //'Hoja de morbilidad obstétrica'
            )
            ?.subSections.find(
              (sub: SubSectionForm) => sub.id == Number(element)
            )
          if (
            item == undefined ||
            item.userResponseValue === 'Otro' ||
            item.userResponseValue === 'Otra' ||
            (dependsOnValue != null &&
              dependsOnValue
                .split('|')
                .find(x => x == item?.userResponseValue) != undefined) ||
            (dependsOnValue === null && item?.userResponseValue === true) ||
            (dependsOnValue === '>0' && item?.userResponseValue > 0) ||
            (dependsOnValue === '!=null' && item?.userResponseValue != null) //||
          ) {
            resp = true
          }
        })
        return resp
      } finally {
        //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
      }
    },

  getItemCurrentCondition:
    state =>
    (
      children: string,
      section: string,
      dependsOn: string,
      dependsOnValue: string | null
    ) => {
      try {
        //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, true)
        let resp = false
        if (dependsOn == null) return true
        let depends = dependsOn.split('|')
        depends.forEach((element: string) => {
          let item = state.currentCondition
            .find(
              (event: SectionForm) =>
                event.children == children && event.section == section //'Hoja de morbilidad obstétrica'
            )
            ?.subSections.find(
              (sub: SubSectionForm) => sub.id == Number(element)
            )
          if (
            item == undefined ||
            item.userResponseValue === 'Otro' ||
            item.userResponseValue === 'Otra' ||
            (dependsOnValue != null &&
              dependsOnValue
                .split('|')
                .find(x => x == item?.userResponseValue?.toString()) !=
                undefined) ||
            (dependsOnValue === null && item?.userResponseValue === true) ||
            (dependsOnValue === '>0' && item?.userResponseValue > 0) ||
            (dependsOnValue === '!=null' && item?.userResponseValue != null) //||
          ) {
            resp = true
          }
        })
        return resp
      } finally {
        //commit(PatientMutations.SET_LOADER_CONSULTATIONS_LIST, false)
      }
    },

  haveClinicalHistory(state: PatientState): boolean {
    return state.clinicalHistory.length === 0 ? false : true
  }
}

// function validateDepends(dependsOn: any): string {
//   switch (dependsOn) {
//     case '246':
//       return 'No es bueno para el Binomio'
//     default:
//       return 'Otro'
//   }
// }
